<template>
   <div class="home">
        <header class="header">
           <h1>考核评分系统<span v-if="isTestEnvironment">{{`(${isTestEnvironment})`}}</span></h1>
           <el-dropdown @command="handleCommand" class="h-username">
                <span class="p-pointer">{{$store.state.login.userinfo['user_name']}}</span>
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="userQuit">登出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </header>
        <div class="sidebar">
           <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
            text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
                <template v-for="item in section">
                    <template v-if="item.children">
                        <el-submenu :index="item.path" :key="item.path">
                            <template slot="title">
                                <i :class="item.icon"></i><span slot="title">{{ item.name }}</span>
                            </template>
                            <template v-for="subItem in item.children">
                                <el-submenu v-if="subItem.children" :index="subItem.path" :key="subItem.path">
                                    <template slot="title">{{ subItem.name }}</template>
                                    <el-menu-item v-for="(threeItem,i) in subItem.children" :key="i" :index="threeItem.path">
                                        {{ threeItem.name }}
                                    </el-menu-item>
                                </el-submenu>
                                <el-menu-item v-else :index="subItem.path" :key="subItem.path">
                                    {{ subItem.name }}
                                </el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item :index="item.path" :key="item.path">
                            <i :class="item.icon"></i><span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </div>
        <div class="content-box" ref="box">
            <router-view></router-view>
        </div>
   </div>
</template>

<script>
import { sumSidebar } from '@/assets/js/message.js'
import storage from '@/assets/js/storage.js'
export default {
    data(){
        return {
            collapse: false,
            section:[],             //侧边导航数据
        }
    },
    created(){
        let section=[];
        const userMessage=storage.localGet('user');
        // this.section=sumSidebar.filter(t=>t.rank>=userMessage.rank);
        this.section=userMessage.menus;
    },
    computed:{
        onRoutes(){
            const path=this.$route.path;
            if(path === '/setAssessFormWrite'){ //同一个导航跳转不同页面高亮
                return '/assessFormSetting'
            }
            return path;
        },
        isTestEnvironment () {
            if(location.hostname === 'ae.wiltechs.com'){
                return '测试环境'
            }
            return ''
        }
    },
    watch:{
        '$store.state.home.preview':function(){
            this.$refs.box.scrollTo(0,750)
        }
    },
    methods:{
        handleCommand(command) {
            if(command === 'userQuit'){
                this.$router.push('/login');
                localStorage.removeItem('user')
            }
        },
        goPageHome(){
            this.$router.push('/')
        },
    },
}
</script>

<style scoped>
    .home{
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 60px;
        font-size: 22px;
        color: #fff;
        background-color: #242f42;
    }
    .header h1{
        margin: 0;
        font-size: 20px;
        line-height: 60px;
        margin-left: 20px;
        display: inline-block;
    }
    .h-username{
        color: #ffffff;
        position: absolute;
        right: 20px;
        line-height:60px;
    }
    .sidebar{
        display: block;
        position: absolute;
        left: 0;
        top: 60px;
        bottom:0;
        overflow-y: auto;
        width:200px;
    }
    .sidebar > ul {
        height:100%;
    }
    .content-box{
        margin-left: 200px;
        height: 100%;
        /* height: calc(100% - 100px); */
        box-sizing: border-box;
        background: #f0f2f5;
    }
    .p-pointer{
        display: inline-block;
    }
    /*菜单导航选中背景色*/
    /* .el-menu-item.is-active { 
        background-color: rgb(40, 52, 70) !important;
    } */
</style>


